import { render, staticRenderFns } from "./currentDayLoan.vue?vue&type=template&id=12771125&scoped=true"
import script from "./currentDayLoan.vue?vue&type=script&lang=js"
export * from "./currentDayLoan.vue?vue&type=script&lang=js"
import style0 from "./currentDayLoan.vue?vue&type=style&index=0&id=12771125&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12771125",
  null
  
)

export default component.exports